module.exports = __webpack_public_path__ + "media/assets/icons/journal-83f84115986ccdf4cf38fcb1d82ee216.svg";